/**
 * GirlyGrove Fixed-Price Bundles (Feb 2026)
 * -----------------------------------------
 * Replaces the old B1G1 / B1G2 BOGO model.
 *
 *   • It-Girl Box : pick ANY 3 pieces for ₹499
 *   • Glam Box    : pick ANY 5 pieces for ₹799
 *   • Dream Box   : pick ANY 7 pieces for ₹1,199 + assured free gift
 *
 * Glam Box & Dream Box pull from the SAME Shopify collection (`dream1199`).
 * It-Girl Box pulls from `itgirl499`.
 *
 * Shiprocket discount codes (configured in Fastrr): ITGIRL499, GLAM799, DREAM1199.
 * Those are AUTOMATIC — the website only displays the value visually.
 */

export const BUNDLES = {
  "it-girl": {
    slug: "it-girl",
    code: "ITGIRL499",
    name: "It-Girl Box",
    tagline: "Pick any 3 for ₹499",
    qty: 3,
    price: 499,
    collectionHandles: ["itgirl499", "buy-1-get-1-free"],
    hasFreeGift: false,
    accent: "#D4537E",       // blush
    softBg: "#FBE8EF",
    offerPill: "₹499 · 3 pieces",
    heroCopy: "Three pieces that love every outfit back.",
  },
  glam: {
    slug: "glam",
    code: "GLAM799",
    name: "Glam Box",
    tagline: "Pick any 5 for ₹799",
    qty: 5,
    price: 799,
    collectionHandles: ["dream1199", "buy-1-get-2-free"],
    hasFreeGift: false,
    accent: "#C5985A",       // gold
    softBg: "#FBEED6",
    offerPill: "₹799 · 5 pieces",
    heroCopy: "Five favourites, one golden steal.",
  },
  dream: {
    slug: "dream",
    code: "DREAM1199",
    name: "Dream Box",
    tagline: "Pick any 7 for ₹1,199 + Assured Free Gift",
    qty: 7,
    price: 1199,
    collectionHandles: ["dream1199", "buy-1-get-2-free"],
    hasFreeGift: true,
    accent: "#4A2C35",       // plum
    softBg: "#F0DFE6",
    offerPill: "₹1,199 · 7 pieces + Gift",
    heroCopy: "The whole look. The free gift. The feeling.",
  },
};

export const BUNDLE_LIST = [BUNDLES["it-girl"], BUNDLES.glam, BUNDLES.dream];
